import React from 'react';

// Utils
import { generateHeaderForQuestion } from 'Shared/utils/Reviews.utils';

// Helpers
import * as ReviewFormTemplatesHelpers from 'Shared/model_helpers/ReviewFormTemplates.helper';

// Components
import { WpContainer, WpContainerHeader, WpContainerBody, WpContainerFooter } from 'Wpds/components/container';
import { WpButton, WpButtonGroup } from 'Wpds/components/button';
import { WpCollapsible } from 'Wpds/components/collapsible';
import MultilineDescription from '../MultilineDescription/MultilineDescription';

import './TextareaQuestion.scss';

type Props = {
  question;
  isOpen: boolean;
  handleMoveNext?: () => void;
  handleMoveBack?: () => void;
};

const TitleDescriptionSection = ({ question, isOpen, handleMoveNext, handleMoveBack }: Props) => {
  const header = generateHeaderForQuestion({ question });
  const description = ReviewFormTemplatesHelpers.getQuestionDescription(question);

  const baseClassName = 'TitleDescriptionSection';

  return (
    <WpContainer className={baseClassName}>
      <WpContainerHeader>
        <p>{header}</p>
      </WpContainerHeader>

      <WpCollapsible open={isOpen}>
        <>
          {description && (
            <WpContainerBody>
              <MultilineDescription description={description} />
            </WpContainerBody>
          )}
          {(handleMoveBack || handleMoveNext) && (
            <WpContainerFooter justifyContent="flexEnd">
              <WpButtonGroup>
                {handleMoveBack && (
                  <WpButton onClick={handleMoveBack} variant="tertiary">
                    Back
                  </WpButton>
                )}
                {handleMoveNext && <WpButton onClick={handleMoveNext}>Next</WpButton>}
              </WpButtonGroup>
            </WpContainerFooter>
          )}
        </>
      </WpCollapsible>
    </WpContainer>
  );
};

export default TitleDescriptionSection;
